import { ThemeColors } from '../../../'

export interface ExtensionBadgeColors {
  Background: {
    Default: ThemeColors
  }
  Border: {
    Default: ThemeColors
  }
  FontColor: {
    Default: ThemeColors
  }
}

export const extensionBadgeColors: ExtensionBadgeColors = {
  Background: {
    Default: {
      default: 'transparent',
    },
  },
  Border: {
    Default: {
      default: 'brand.fg',
    },
  },
  FontColor: {
    Default: {
      default: 'brand.fg',
    },
  },
}
